module.exports = __webpack_public_path__ + "static/media/almac.69155fb9.png";